import { render } from "./eb-thumbnail-card.vue?vue&type=template&id=bee4471a"
import script from "./eb-thumbnail-card.vue?vue&type=script&lang=ts"
export * from "./eb-thumbnail-card.vue?vue&type=script&lang=ts"
script.render = render

export default script